<template v-if="isVisible">
  <aside id="head_campaign">
      <div v-for="item in items" :key="item.id">
        <a :href="item.link">
          <div class="container">
            <h2>
             {{ item.title }}
            </h2>
          </div>
        </a>
      </div>

    <div class="spinner_pickup" v-if="isLoading">
      <pulse-loader
        :loading="isLoading"
        :color="'#f5f5f5'"
        :size="'10px'"
      ></pulse-loader>
    </div>
  </aside>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      isLoading: false,
    };
  },
  props: {
    url: String,
  },
  methods: {
    getPosts() {
      this.isLoading = true;
      var self = this;
      axios
        .get(this.url)
        // Success
        .then((response) => {
          if (response.status != 200) {
            console.log(response.statusText);
            exit;
          }
          self.items = response.data;
          this.isLoading = false;
        })
        // Error
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getPosts();
  },
};
</script>